import React from 'react';
import ContentWithImagesComponent from '../general/ContentWithImagesComponent';
// Images
import AboutImage1 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-with-green-flail.jpg'
import AboutImage2 from '../../assets/images/main/mistress-sammi-smith-trans-dominatrix-on-sofa-with-whip.jpg'
import { CONTACT_PAGE_URL, GALLERY_PAGE_URL } from '../../utils/Routes';
import { Link } from 'react-router-dom';

function AboutMeSection() {
  return (
    <ContentWithImagesComponent
      imageOne={AboutImage1}
      imageTwo={AboutImage2}
      imageFive={AboutImage1}
    >
      {/* About Me Section */}
      <section className='mb-6 py-4 lg:py-12'>
        <h2 className='text-5xl mb-4 font-medium font-titleFont underline underline-offset-8 decoration-from-font bg-colour2 rounded-md px-4 py-1 mr-2 md:mr-8 lg:mr-22 shadow-cardShadowBold shadow-colour4/60'>
          About Me
        </h2>
        <div className='grid gap-4 px-2'>
          <p>
            Welcome to my world of self-expression and pleasure. I thrive on the
            attention of others and take immense satisfaction in knowing that my
            pictures, videos, and writing bring enjoyment and excitement to
            those who appreciate them. I welcome friend requests but truly value
            a thoughtful message first.
          </p>
          <p>
            Exhibitionism is a huge part of who I am, and I revel in the idea
            that my content fuels desires and fantasies. Beyond visuals, I also
            share my thoughts, journal entries, and original erotic fiction for
            those who enjoy a deeper connection through words. My writing is an
            extension of my identity, a way to share my experiences and engage
            with those who appreciate my world.
          </p>
          <p>
            While I adore feminization and sissification themes, I want to be
            absolutely clear—I am a transgender woman, not a crossdresser. I
            expect to be treated as any other woman, or rather, as the kinky and
            confident woman that I am. Disrespectful language has no place here,
            and I will not tolerate it. Mutual respect and consent are
            everything to me.
          </p>
        </div>
      </section>

      {/* My Philosophy Section */}
      <section>
        <h3 className='text-5xl mb-4 font-medium font-titleFont underline underline-offset-8 decoration-from-font bg-colour2 rounded-md px-4 py-1 mr-4 md:mr-4 lg:mr-28 shadow-cardShadowBold shadow-colour4/60'>
          My Philosophy
        </h3>
        <div className='grid gap-4 px-2'>
          <p>
            Consent and appreciation go hand in hand. I love seeing fan art and
            tributes created in my honor, but I deeply value respect. If you
            wish to repost any of my content, please ask first. I create custom
            content and share both public and private updates, so don’t be shy
            about reaching out.
          </p>
          <p>
            If you enjoy my work and want to show your support, feel free to
            message me about my wishlist—generosity is always appreciated! My
            goal is to create an environment where fantasy, pleasure, and
            authenticity intertwine, giving you an experience that is both
            intimate and exhilarating.
          </p>
          <p>
            So, whether you’re here to enjoy my pictures, dive into my writing,
            or engage with my world in a deeper way, you’re welcome to explore.
            Just remember—respect, consent, and appreciation are the keys to
            making this space as fulfilling for you as it is for me. Happy
            fapping, y’all!
          </p>
        </div>
        <div className='grid md:grid-flow-col gap-4 items-end justify-center mt-4 lg:mt-12 py-6 lg:py-0'>
          <aside className='mx-auto'>
            <Link to={CONTACT_PAGE_URL} title='Contact page link' aria-label='Contact page link' className='blinking-button active:scale-90'>
              Book a Session
            </Link>
          </aside>
          <aside className='mx-auto'>
            <Link
              href={GALLERY_PAGE_URL}
              title='Gallery page link'
              aria-label='Gallery page link'
              className='blinking-button active:scale-90'
            >
              View my Gallery
            </Link>
          </aside>
        </div>
      </section>
    </ContentWithImagesComponent>
  );
}

export default AboutMeSection;
